import { Button } from "react-admin";
import RegeneratePdfButton from "../../commercialDocuments/components/RegeneratePdfButton";

interface IShowInvoicePdfButton {
  invoiceId: number;
  invoiceNumber: string;
  pdfUrl: string | null;
  provider: any;
}

const ShowInvoicePdfButton = ({
  invoiceId,
  invoiceNumber,
  pdfUrl,
  provider,
}: IShowInvoicePdfButton) => {
  const GetPdf = (id: number) => {
    provider
      .getOne("invoices", {
        id: id,
      })
      .then(({ data }: any) => {
        window.open(data.pdfUrl, "_blank");
      });
  };

  return (
    <>
      {pdfUrl !== null && (
        <Button
          onClick={() => {
            GetPdf(invoiceId);
          }}
          label="Show PDF"
        />
      )}

      <RegeneratePdfButton accountingDocumentNumber={invoiceNumber} />
    </>
  );
};

export default ShowInvoicePdfButton;
